<template>
    <div>
        <div class="flex feature-links">
            <form-select
                label="Link This Signature"
                :value="linkType"
                @change="changeLinkType"
                paddingTop="1em"
            >
                <option value="">Not Linked</option>
                <option value="contact">Contact Search</option>
                <option value="textboxes">Textboxes</option>
            </form-select>
            <form-select
                v-if="linkType === 'contact'"
                label="Linked Contact Search"
                :value="feature.featureLinks.fname"
                @change="setAllLinks"
                paddingTop="1em"
                width="100%"
            >
                <option value="">Select a contact search</option>
                <option
                    v-for="feature in contactSearchFeatures"
                    :key="feature.id"
                    :value="feature.id"
                >{{ feature.name }}</option>
            </form-select>
            <div v-else-if="linkType === 'textboxes'">
                <form-select
                    label="First Name Textbox"
                    :value="feature.featureLinks.fname"
                    @change="setLink('fname', $event)"
                    paddingTop="1em"
                    width="100%"
                >
                    <option value="">Select a textbox</option>
                    <option
                        v-for="feature in textboxFeatures"
                        :key="feature.id"
                        :value="feature.id"
                    >{{ feature.name }}</option>
                </form-select>
                <form-select
                    label="Last Name Textbox"
                    :value="feature.featureLinks.lname"
                    @change="setLink('lname', $event)"
                    width="100%"
                >
                    <option value="">Select a textbox</option>
                    <option
                        v-for="feature in textboxFeatures"
                        :key="feature.id"
                        :value="feature.id"
                    >{{ feature.name }}</option>
                </form-select>
                <form-select
                    label="Email Textbox"
                    :value="feature.featureLinks.email"
                    @change="setLink('email', $event)"
                    width="100%"
                >
                    <option value="">Select a textbox</option>
                    <option
                        v-for="feature in textboxFeatures"
                        :key="feature.id"
                        :value="feature.id"
                    >{{ feature.name }}</option>
                </form-select>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex';

    export default {
        name: 'PropTabSignatureSettings',
        props: {
            feature: {
                required: true
            }
        },
        data() {
            return {
                linkType: ''
            }
        },
        computed: {
            ...mapGetters({
                featureById: 'form/featureById',
                features: 'form/features'
            }),
            contactSearchFeatures() {
                return this.features.filter(f => f.type === 'contactSearch');
            },
            textboxFeatures() {
                return this.features.filter(f => f.type === 'textbox');
            }
        },
        methods: {
            changeLinkType(type) {
                this.setAllLinks(null);
                this.linkType = type;
            },
            setLink(item, featureId) {
                this.update('featureLinks', {
                    ...this.feature.featureLinks,
                    [item]: featureId || null
                });
            },
            setAllLinks(featureId) {
                let links = {};
                for (let item in this.feature.featureLinks) {
                    links[item] = featureId || null;
                }
                this.update('featureLinks', links);
            },
            update(prop, val) {
                this.$store.commit('form/updateFeature', {
                    feature: this.feature,
                    updates: { [prop]: val }
                });
            },
            init() {
                this.linkType = '';
                for (let item in this.feature.featureLinks) {
                    let featureId = this.feature.featureLinks[item];
                    if (!featureId) continue;
                    let feature = this.featureById(featureId);
                    if (!feature) {
                        this.setLink(item, null);
                        continue;
                    }
                    if (!this.linkType) {
                        if (feature.type === 'contactSearch') {
                            this.linkType = 'contact';
                        } else {
                            this.linkType = 'textboxes';
                        }
                    }
                }
            }
        },
        watch: {
            feature() {
                this.init();
            }
        },
        mounted() {
            this.init();
        }
    };
</script>

<style lang="scss" scoped>
    .flex {
        display: flex;
        justify-content: space-between;

        > *:not(:first-child) {
            margin-left: 1em;
        }
    }

    .feature-links {
        @include well;

        > *:last-child {
            flex-grow: 1;
        }
    }
</style>
